module.exports = __webpack_public_path__ + "img/3x.4e4eeab.jpg";